module.exports = __webpack_public_path__ + "img/Маңғыстау облысы.3b4c2862.png";